import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import _ from "lodash";
import React, { useCallback, useState } from "react";

const SearchComponent: React.FC<SearchComponentProps> = ({
  onSearch,
  width = "100%",
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useCallback(
    _.debounce((value: string) => onSearch(value), 500),
    [onSearch]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  return (
    <Input
      placeholder="Search"
      size="large"
      prefix={<SearchOutlined />}
      value={searchTerm}
      onChange={handleChange}
      style={{ width: width }}
      allowClear
    />
  );
};

export default SearchComponent;
